import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeMenu: null,
  activeComponent: null,
  displayFacilityDDL: false,
  facilityId: null,
  functionalAreaId: null,
  messageHandler: {
    type: null,
    message: null,
    list: null
  },
};

export const SelectedValues = createSlice({
  name: "SelectedValues",
  initialState,
  reducers: {
    setActiveMenu: (state, action) => {
      state.activeMenu = action.payload;
    },
    setActiveComponent: (state, action) => {
      state.activeComponent = action.payload;
    },
    setDisplayFacilityDDL: (state, action) => {
      state.displayFacilityDDL = action.payload;
    },
    setFacilityId: (state, action) => {
      state.facilityId = action.payload;
    },
    setFunctionalAreaId: (state, action) => {
      state.functionalAreaId = action.payload;
    },
    setMessageHandler: (state, action) => {
      state.messageHandler = action.payload;
    },
  },
});

export const {
  setActiveMenu,
  setActiveComponent,
  setDisplayFacilityDDL,
  setFacilityId,
  setFunctionalAreaId,
  setMessageHandler,
} = SelectedValues.actions;

export default SelectedValues.reducer;
